import { useEffect, useMemo, useState } from "react";
import { getCategoriesByID } from "../../auth/apiCategory";

// Catégories LIÉES à un Provider Product (multi-catégories, comme Product.
// categoriesID côté Seller) : noms (chemins) + UNION des filtres de toutes ces
// catégories, dédupliquée par le VRAI id du filtre (jamais par libellé). Une
// requête par catégorie non encore connue, mise en cache.
// Exported at module level (in addition to being returned by the hook below)
// so a caller who doesn't want/need the multi-category fetch/cache -- e.g.
// editProduct.jsx (Seller), which keeps its own mono-category state to
// preserve its subFilter cascade -- can still reuse this exact id-resolution
// logic without invoking the hook.
export const filterIdOf = (k) => String(k?._id?._id ?? k?._id ?? "");

const useLinkedCategories = (ids) => {
  const [cache, setCache] = useState({});
  const [loading, setLoading] = useState(false);
  const key = (ids || []).join(",");

  useEffect(() => {
    const missing = (ids || []).filter((id) => !cache[id]);
    if (!missing.length) return undefined;
    let cancelled = false;
    setLoading(true);
    Promise.all(missing.map((id) => getCategoriesByID(id).then((d) => [id, d]).catch(() => [id, null]))).then((entries) => {
      if (cancelled) return;
      setCache((prev) => {
        const next = { ...prev };
        entries.forEach(([id, d]) => {
          next[id] = d && !d.error ? { name: d.cartegory?.name || [], filter: d.filter || [] } : { name: [], filter: [], failed: true };
        });
        return next;
      });
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  const linked = (ids || []).map((id) => ({ _id: id, name: cache[id]?.name || [] }));
  const filterList = useMemo(() => {
    const seen = new Set();
    const out = [];
    (ids || []).forEach((id) => {
      (cache[id]?.filter || []).forEach((k) => {
        const fid = filterIdOf(k);
        if (!fid || seen.has(fid)) return;
        seen.add(fid);
        out.push(k);
      });
    });
    return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, cache]);

  return { linked, filterList, loading, filterIdOf };
};

export default useLinkedCategories;
